import Image from '@/components/UI/Image';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { useEffect, useMemo, useState } from 'react';
import css from './index.module.scss';
const { EFPic } = createEFPic('/media/mm100/pc/modals/');

export default function CablePack() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [isEnterA, setIsEnterA] = useState(false);
    const [isEnterB, setIsEnterB] = useState(false);
    const [bottomText, setBottomText] = useState(false);
    const { locale } = useRouter();
    const circleList = [
        { bgColor: '#1dc132', left: '0' },
        { bgColor: '#1dc132', left: '90px' },
        { bgColor: '#1dc132', left: '91px' },
        { bgColor: '#1dc132', left: '125px' },
        { bgColor: '#ff813e', left: '5px' },
        { bgColor: '#1dc132', left: '151px' },
        { bgColor: '#ff813e', left: '5px' },
        { bgColor: '#1dc132', left: '150px' },
        { bgColor: '#ff813e', left: '5px' },
        { bgColor: '#1dc132', left: '157px' },
    ];

    const imgLocal = getImageLocal(locale, ['au', 'cn']);

    // 第1侦动画
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.cablePack .img_top', //触发元素
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0.5, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '200%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        let timerA1: any;
        sceneA1.on('enter', function () {
            setIsEnterA(true);
            clearTimeout(timerA1);
        });
        sceneA1.on('leave', function () {
            timerA1 = setTimeout(() => {
                setIsEnterA(false);
            }, 500);
        });
        AniContainer.addScene(sceneA1);
    }, []);

    // 第2侦动画
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.cablePack .bottom', //触发元素
            offset: 380, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '200%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        let timerA1: any;
        sceneA1.on('enter', function () {
            setIsEnterB(true);
            clearTimeout(timerA1);
        });
        sceneA1.on('leave', function () {
            timerA1 = setTimeout(() => {
                setIsEnterB(false);
            }, 500);
        });
        AniContainer.addScene(sceneA1);
    }, []);

    const createdBottomContent = useMemo(() => {
        if (!bottomText) {
            return (
                <>
                    <p className="text1">{t('presale.product.modals.cable_text1')}</p>
                    <p className="text2">{t('presale.product.modals.cable_text2')}</p>
                </>
            );
        }
        const textArr = ['cable_content1_desc1', 'cable_content1_desc2', 'cable_content1_desc4', 'cable_content2_desc1', 'cable_content2_desc2'];
        return (
            <>
                {textArr.map((item, index) => (
                    <div className="content_item" key={item}>
                        <div style={{ width: '90px', height: '90px' }}>
                            <EFPic name={[`line${index + 1}.webp`, `line${index + 1}.jpg`]} className="fullImgs" alt={t(`presale.product.modals.${item}`)} />
                        </div>
                        <div className="content_right">
                            <h6>{t(`presale.product.modals.${item}`)}</h6>
                            <p>{t(`presale.product.modals.cable_spec${index + 1}`)}</p>
                        </div>
                    </div>
                ))}
            </>
        );
    }, [bottomText]);

    return (
        <div className={`cablePack ${css.cablePack}`}>
            <div className={`cablePackBox ${isEnterA ? 'isEnterA' : ''} ${isEnterB ? 'isEnterB' : ''}`}>
                <p className="cable_title">{t('presale.product.modals.cable_title')}</p>
                <p className="cable_learn">{t('presale.product.modals.cable_learn')}</p>
                <div className="cable-type">
                    <div className="circle-common"></div>
                    <div className="circle-dec">{t('presale.product.modals.cable_input')}</div>
                    <div className="circle-common circle-red"></div>
                    <div className="circle-dec">{t('presale.product.modals.cable_output')}</div>
                </div>
                <div className="img_top">
                    <Image
                        src={`/media/mm100/pc/modals/cablePack_a2_${imgLocal}.png`}
                        layout="fill"
                        className="fullImgs"
                        alt={t('presale.product.modals.cable_learn')}
                        aria-label={t('presale.product.modals.cable_learn')}
                    />
                    <div className="circle-box" style={{ opacity: isEnterA ? '1' : '0' }}>
                        {circleList.map((item, index) => (
                            <div key={index} className="circle-item" style={{ backgroundColor: item.bgColor, marginLeft: item.left }}></div>
                        ))}
                    </div>
                    <div className="line-box">
                        <div className="line line-1"></div>
                        <div className="rectangle-1"></div>
                        <div className="line line-2"></div>
                        <div className="rectangle-2"></div>
                        <div className="line line-3"></div>
                        <div className="line line-4"></div>
                        <div className="line line-5" style={{ display: locale === 'us' ? 'block' : 'none' }}></div>
                        <div className="line-text" style={{ display: locale === 'us' ? 'block' : 'none' }}>
                            {t.rich('presale.product.modals.cable_line_text', {
                                line1: (child: any) => <div className="sub-text">{child}</div>,
                            })}
                        </div>
                    </div>
                    <div className="img_top_in">
                        <Image
                            src="/media/mm100/pc/modals/cablePack_a1.png"
                            layout="fill"
                            className="fullImgs"
                            alt={t('presale.product.modals.cable_learn')}
                            aria-label={t('presale.product.modals.cable_learn')}
                        />
                    </div>

                    <div className="img_lines_a_box">
                        <div className="img_lines_a line">
                            <div className="line1"></div>
                            <div className="line2"></div>
                            <div className="text_a text">{t('presale.product.modals.cable_content1_desc1')}</div>
                        </div>
                        <div className="img_lines_a0 line">
                            <div className="line1"></div>
                            <div className="line2"></div>
                            <div className="text_a0 text">{t('presale.product.modals.cable_content1_desc2')}</div>
                        </div>
                        <div className="img_lines_a1 line">
                            <div className="line1"></div>
                            <div className="line2"></div>
                            <div className="text_a1 text">{t('presale.product.modals.cable_content1_desc3')}</div>
                        </div>
                        <div className="img_lines_a2 line">
                            <div className="line1"></div>
                            <div className="line2"></div>
                            <div className="text_a1 text">
                                {['us'].includes(locale)
                                    ? t('presale.product.modals.cable_content1_desc4_new')
                                    : t('presale.product.modals.cable_content1_desc4')}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom">
                    <div className="img">
                        <Image
                            src={`/media/mm100/pc/modals/cablePack_b1_${imgLocal}.png`}
                            layout="fill"
                            className="fullImgs"
                            alt={t('presale.product.modals.cable_text1')}
                            aria-label={t('presale.product.modals.cable_text1')}
                        />

                        <div className="img_bottom_in_2">
                            <Image
                                src="/media/mm100/pc/modals/cablePack_b3.png"
                                layout="fill"
                                className="fullImgs"
                                alt={t('presale.product.modals.cable_learn')}
                                aria-label={t('presale.product.modals.cable_learn')}
                            />
                        </div>
                        <div className="img_lines_b2 line_b">
                            <div className="b-title">{t('presale.product.modals.cable_content2_title2')}</div>
                            <div className="text_b2 text">{t('presale.product.modals.cable_content2_desc2')}</div>
                            <div className="text-line"></div>
                            <div className="text-point"></div>
                        </div>
                        <div className="img_bottom_in_3">
                            <Image
                                src="/media/mm100/pc/modals/cablePack_b4.png"
                                layout="fill"
                                className="fullImgs"
                                alt={t('presale.product.modals.cable_learn')}
                                aria-label={t('presale.product.modals.cable_learn')}
                            />
                        </div>
                        <div className="img_bottom_in_1">
                            <Image
                                src="/media/mm100/pc/modals/cablePack_b2.png"
                                layout="fill"
                                className="fullImgs"
                                alt={t('presale.product.modals.cable_learn')}
                                aria-label={t('presale.product.modals.cable_learn')}
                            />
                        </div>
                        <div className="img_lines_b1 line_b">
                            <div className="b-title b1-title">{t('presale.product.modals.cable_content2_title1')}</div>
                            <div className="text_b1 text">{t('presale.product.modals.cable_content2_desc1')}</div>
                            <div className="text-line line2"></div>
                            <div className="text-point point2"></div>
                        </div>
                    </div>
                    <div className={bottomText ? 'content img_list' : 'content'}>
                        {locale === 'us' && (
                            <div className={bottomText ? 'btn btn_text' : 'btn'} onClick={() => setBottomText(!bottomText)}>
                                &times;
                            </div>
                        )}
                        {createdBottomContent}
                    </div>
                </div>
            </div>
        </div>
    );
}
